import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/brand-logo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <BrandLogo size="lg" className="justify-center mb-8" animated={true} />
        <h1 className="text-6xl font-display mb-4" style={{ color: "var(--fs-forest)" }}>404</h1>
        <p className="text-muted-foreground mb-8">A página que você procura não existe.</p>
        <Link href="/">
          <Button variant="outline" className="rounded-full gap-2">
            <ArrowLeft className="w-4 h-4" />Voltar ao início
          </Button>
        </Link>
      </div>
    </div>
  );
}
